import BedOccupancy from './Container';

export default BedOccupancy;
